module.exports = __webpack_public_path__ + "img/shikshatam.739a7695.jpg";